import { useState } from 'react'
import Head from 'next/head'
import Image from 'next/image'
import Link from 'next/link'
import styles from "../styles/Pages/Restaurant.module.scss"
import Gallery from '../components/Reusable/Gallery/Gallery'
import Topbanner from '../components/Reusable/Banner/Topbanner'
import Slider from "react-slick";
import Accordion from '../components/Reusable/Accordion/Accordion'
import { gsap } from "gsap/dist/gsap";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
import DiningPageForm from '../components/Reusable/Form/DiningPageForm'
import HomeBanner from '../components/Reusable/Banner/HomeBanner'
import CorporateToursForm from '../components/Reusable/Form/CorporateToursForm'
import Schema from '../components/Schema'
import { AncorSecoundaryButton } from '../components/Reusable/Buttons/Buttons'

export default function CorporateTours() {
    const [activeIndex, setActiveIndex] = useState(null);

    const testimonial = [
        {
            name: "Shaifali Goyal",
            title: "From India",
            description: "The canteen inside offers a wide range of options to eat and drink with lovely seats. There are different shops like bakery, apple chips, furniture, food and beauty items, etc."
        },
        {
            name: "Saket Suman",
            title: "From India",
            description: "well placed on the edge that it gives you extra thrill. Apart from rides, it has decent facilities like cafeteria, bakery, restaurant as well."
        },
        {
            name: "Nick Sha",
            title: "From India",
            description: "Activities are good, i. Suggest go with children they enjoy a lot then adults,And don't forget to eat from their is one bakery shop awsm and fresh food I love it."
        },
    ];

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    const faqsData = [
        {
            title: 'What kind of corporate events do you host?',
            content: `We cater to a variety of corporate events, including team-building retreats, conferences, incentive trips, and product launches.`
        },
        {
            title: 'What adventure activities do you offer?',
            content: `We offer a range of outdoor activities like go-karting, ziplining, sky swinger, rope courses, frisbee and more. Indoor activities are also available.`
        },
        {
            title: 'What kind of conference facilities do you have?',
            content: `Our spacious conference halls are equipped with state-of-the-art audio-visual technology and can accommodate groups of all sizes.`
        },
        {
            title: 'Do you offer accommodation on-site?',
            content: `Yes, we have The Twin Towers Hotel, featuring comfortable and well-appointed rooms to accommodate your entire team.`
        },
        {
            title: 'How can I customize a corporate retreat package?',
            content: `Simply contact our sales team to discuss your requirements. We'll work with you to create a personalized plan that fits your budget and goals.`
        },
    ];

    const handleScrollDown = (e) => {
        gsap.registerPlugin(ScrollToPlugin);
        e.stopPropagation()
        gsap.to(window, {
            speed: 100,
            duration: 1,
            scrollTo: {
                y: "#book-a-table",
                offsetY: 70,
            }
        })
    };

    const safetyLists = [
        {
            title: 'Rigorous Ride Inspections',
            icon: '/icons/groups/inspections.png'
        },
        {
            title: 'Staff Training and Safety Protoclos',
            icon: '/icons/groups/staff.png'
        },
        {
            title: 'Clear and Visible Safety Signage',
            icon: '/icons/groups/clear.png'
        },
        {
            title: 'Emergency Response Preparedness',
            icon: '/icons/groups/emergency.png'
        },
        {
            title: 'Safety Briefings for Groups',
            icon: '/icons/groups/safety.png'
        },
    ]

    return (
        <>
            <Head>
                <title>Corporate Tour Packages in Shimla | Adventure Resorts</title>
                <meta name="description" content="Explore Corporate Tour Packages in Shimla with Adventure Resorts offering various adventure activities & team-building exercises. Bond with your team today." />
                <meta name="keywords" content="Team Activities at Shimla, Corporate Picnic at Shimla, Corporate Outing in Shimla, Adventure Activity for group, Corporate Office group tour packages" />
                <link rel="icon" href="/favicon.png" />
                <link rel="canonical" href="https://www.adventureresortkufri.com/corporate-tour" />
            </Head>

            <Schema name="CorporateTourFaq" />

            <HomeBanner title={" Adventure Activities & Team Building"} bgImage={"/images/tours/corporate-tours-banner.png"} target="#firstsec" />

            <section className={`${styles.story_sec} common_padding`} id='firstsec'>
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-md-8 common_title'>
                            <h2> Unforgettable Corporate Retreats in Shimla</h2>
                            {/* <Image src="/icons/line.svg" width={120} height={2} alt='Icon'></Image> */}
                            <p>Escape the boardroom, ignite teamwork!  Adventure Resorts Kufri, nestled amidst the majestic Himalayas, offers a transformative corporate retreat experience.  We combine the thrill of adventure activities like go-karting and ziplining with state-of-the-art conference facilities, comfortable accommodations (The Twin Towers Hotel), and spacious dining areas.
                                Unleash hidden potential. Our curated programs transform office stress into outdoor success.  Foster collaboration and reconnect your team in a breathtaking natural setting.  Customized itineraries cater to your specific needs and budget, ensuring a memorable and impactful retreat.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className={`${styles.restaurant_sec}`}>
                <div className='container'>
                    <div className={`${styles.restasurant_main} row align-items-center`}>
                        <div className={`${styles.restaurnat_left} col-md-7`}>
                            <Image src='/images/tours/corporate-tours-page-left.png' alt='Restaurant Image' width={725} height={550}></Image>
                            {/* <img src='/images/restaurant-main.png' alt='Restaurant Image' /> */}
                        </div>
                        <div className={`${styles.restaurnat_right} col-md-5 `}>
                            <div className='common_title'>
                                <h2 className='subhead_animate'>From Office Stress to Outdoor Success</h2>
                                <p>Unleash your team's potential and foster collaboration in a breathtaking natural setting. Our curated corporate packages combine heart-pumping activities like go-karting and ziplining with spacious conference halls and comfortable accommodations.</p>
                                <p>Reconnect, recharge, and return to the office with renewed focus and a stronger team spirit.</p>

                                <AncorSecoundaryButton
                                    redirectPage={'#enquirenow'}
                                    className={'margin_0_auto'}
                                    buttonText={'Enquire Now'} />
                                {/* <Link href='#enquirenow' className='secoundary_btn'>Enquire Now</Link> */}
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <section className={`${styles.stay_sec} common_padding`}>
                <div className='container'>
                    <div className={`${styles.stay_main} row align-items-center`}>
                        <div className={`${styles.stay_left} col-md-5`}>
                            <div className='common_title'>
                                <h2 className='subhead_animate'>Customized Plans for Corporate Groups</h2>
                                <p>We understand no two groups are alike. Our dedicated team crafts personalized itineraries tailored to your specific needs and budget.</p>
                                <p>Choose from a range of activities, conference packages, and catering options to create a memorable and impactful corporate retreat experience.</p>

                                <AncorSecoundaryButton
                                    redirectPage={'#enquirenow'}
                                    className={'margin_0_auto'}
                                    buttonText={'Enquire Now'} />
                                {/* <Link href='#enquirenow' className='secoundary_btn'>Enquire Now</Link> */}
                            </div>
                        </div>
                        <div className={`${styles.stay_right} col-md-7 plan_student_img`}>
                            <Image src='/images/tours/corporate-tours-page-right.png' fill={true} priority alt='Highlight Image'></Image>
                        </div>
                    </div>
                </div>
            </section>

            <section className={`${styles.speciality_sec} common_padding`}>
                <div className='container'>
                    <div className={`${styles.speciality_child} row align-items-center justify-content-center`}>
                        <div className={`${styles.safety_first_sec} col-md-8 common_title text-center mobile_text_center`}>
                            <h2>Safety First</h2>
                            {/* <Image src="/icons/line.svg" width={120} height={2} alt='Icon'></Image> */}

                            <div className={styles.safety_sec_content}>
                                {safetyLists.map((item) => (
                                    <div key={item.title} className={styles.safety_sec_content_card}>
                                        <Image src={item.icon} height={50} width={50} alt={item.title} />
                                        <p>{item.title}</p>
                                    </div>
                                ))}
                            </div>
                            {/* <ul>
                                <li>Lorem ipsum dolor sit amet consectetur.  .</li>
                                <li>Lorem ipsum dolor sit amet consectetur. Urna .</li>
                                <li>Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices.</li>
                                <li>Lorem ipsum dolor sit amet consectetur. Urna integer morbi.</li>
                                <li>Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices.</li>
                            </ul> */}
                        </div>
                    </div>
                </div>
            </section>

            <section className='common_padding'>
                <div className='container common_title text-center'>
                    <h2>A Gallery of Unforgettable Experiences</h2>
                    {/* <Image src="/icons/line.svg" width={120} height={2} alt='icon'></Image> */}

                    <div className='row'>
                        <div className='col-md-12' style={{ margin: '0 auto' }}>
                            <div className="tours_gallery">
                                <div className="tours_gallery_top">
                                    <div className='gallery_img1'>
                                        <Image src={'/images/tours/corporate-tour-gal-1.png'} fill={true} alt='Gallery One'></Image>
                                    </div>
                                    <div className="tours_gallery_top_right">
                                        <div className="gallery_img2">
                                            <Image src={'/images/tours/corporate-tour-gal-2.png'} fill={true} alt='Gallery Two'></Image>
                                        </div>
                                        <div className={styles.tours_gallery_top_right_bottom} style={{ display: 'flex', gap: '10px' }}>
                                            <div className="gallery_img3">
                                                <Image src={'/images/tours/corporate-tour-gal-3.png'} width={250} height={220} alt='Gallery Three'></Image>
                                            </div>
                                            <div className="gallery_img3">
                                                <Image src={'/images/tours/corporate-tour-gal-4.png'} width={250} height={220} alt='Gallery Four'></Image>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tours_gallery_bottom">
                                    <div className="gallery_img4">
                                        <Image src={'/images/tours/corporate-tour-gal-5.png'} width={294} height={225} alt='Gallery Five'></Image>
                                    </div>
                                    <div className="gallery_img4">
                                        <Image src={'/images/tours/corporate-tour-gal-6.png'} width={294} height={225} alt='Gallery Six'></Image>
                                    </div> <div className="gallery_img4">
                                        <Image src={'/images/tours/corporate-tour-gal-7.png'} width={294} height={225} alt='Gallery Seven'></Image>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='common_padding'>
                <div className='container '>
                    <div className='text-center common_title'>
                        <h2 >FAQs</h2>
                        {/* <Image src="/icons/line.svg" width={120} height={2} alt='icon'></Image> */}
                    </div>

                    <div className='row justify-content-center'>
                        <div className="accordion_parent col-md-8">
                            <Accordion items={faqsData} />
                        </div>
                    </div>
                </div>
            </section>
            <section id='enquirenow'>
                <div className='container common_title text-center'>
                    <h2>Let's Talk Adventure! <br />Get a Personalized Quote</h2>
                    {/* <Image src="/icons/line.svg" width={120} height={2} alt='icon'></Image> */}
                    <CorporateToursForm />
                </div>
            </section>

        </>
    )
}


